import { enableTap } from 'core/handlers/TapHandler'
import { gameStorage } from 'services/ElementsStorageService'
import { signal } from 'services/SignalsService'
import { gameId } from 'settings/custom/general'
import { reelsSettings } from 'settings/custom/reels'
import { utils } from 'utils/Utils'

export  class ReelSymbol extends PIXI.Container{
  constructor(symbolPool) {
    super()
    this.images = {}
    this.items = game.models.SpinModel.get().reelSymbols
    this.current = 'A'
    this.type = reelsSettings.items.default
    this.positionY = 0
    this.createSignal()
    this.symbolPool = symbolPool
    this.isSticky = false
    this.updateStates(!!game.models.FreespinModel.get().left)
    enableTap(this, this.sendSignal.bind(this))
  }

  sendSignal(){
    let symbolValueExist = Boolean(gameStorage.get('symbol-value'))
    if (!game.models.AutoLimitModel.isAuto && !game.models.BonusMultiplierModel.isFS && !game.models.WinModel.isWin && symbolValueExist) {
      let currentSymbol = this.valueExistCheck(game.models.PayoutModel.getList()[this.current])
      let numberOfSymbolValues = typeof currentSymbol === 'object' ?  Object.keys(currentSymbol).filter((value) => value > 0).length : 0
      let positionY = (this.pos < 0) ? (this.pos + 3) : this.pos
      let positionX = this.parent.parent.hasOwnProperty('id') ? this.parent.parent.id : this.parent.id
      // todo проверка для HorizontalReel, подумать как убрать
      if (gameId === 5) {
        [positionY, positionX] = [positionX, positionY]
      }

      if (currentSymbol === undefined || !numberOfSymbolValues) {
        return
      }
      signal.dispatch('SHOW-SYMBOL-VALUE:IN', {
        currentSymbol,
        numberOfSymbolValues,
        positionX,
        positionY,
      })
      this.visible = false
      signal.on('SHOW-SYMBOL-VALUE:IN', () => {
        clearInterval(timer)
        this.visible = true
      })
      signal.on('BUTTON:spin', () => {
        this.visible = true
      })
      let timer = setTimeout(() => {
        signal.dispatch('SHOW-SYMBOL-VALUE:OUT')
        this.visible = true
      }, 2000)
    }
  }

  valueExistCheck(symbolValues){
    for (let key in symbolValues) {
      if (symbolValues[key] === 0) {
        delete symbolValues[key]
      }
    }
    return symbolValues
  }

  createSignal(){
    signal.on('WIN-SCATTER-ANIM', () => {
      this.animationScatter()
    })
  }

  updateStates(isFs) {
    for (const state in Object.assign(gameId !== 4 ? { move: true } : {}, reelsSettings.items.states)) {

      const setState =  () => {
        switch (state) {
          case 'static': return () => this.symbol.playStatic(isFs)
          case 'move': return () => this.symbol.playMove()
          case 'stop': return () => this.symbol.playSpineStop()
          case 'dimm': return () => this.symbol.playDim()
          case 'inactive': return () => this.symbol.playDim()
          case 'idle': return  () => this.symbol.playIdleAnimation()
          case 'sticky': return  () => this.symbol.playSticky()
          case 'cascadeWin': return  () => this.symbol.playCascadeWin()
          case 'cascadeVanish': return  () => this.symbol.playCascadeVanish()
          case 'playCascadeDrop': return  () => this.symbol.playCascadeDrop()

        }
      }
      this.images[state] = this.images[state] || {}
      this.images[state] =  setState()
    }
  }

  update(isFs) {
    this.updateStates(isFs)
  }

  resetSymbol(){
    this.images['static'](false)
  }

  playMove() {
    this.symbol.playMove()
  }

  swapSticky(sticky) {
    this.symbol.swapSticky(sticky)
  }

  setSymbol(id) {
    this.current = id

    if(this.symbol){
      if(this.children.length === 0){
        utils.changeParent(this.symbol, this)
      }

      this.removeChildAt( 0)
      this.symbolPool.returnSymbols(this.symbol)
      this.symbol = false
    }
    this.symbol = this.symbolPool.getSymbols(id)

    this.symbol.renderable = true
    this.symbol.isSticky = this.isSticky
    this.addChildAt(this.symbol, 0)

    const reelCount = reelsSettings.itemCount[0]
    if(this.positionY !== 0 && this.positionY > reelCount && this.positionY < reelCount * 2) {

      if(this.type === 'move'){
        this.images[this.type](true)
      }
      else{
        this.images['static'](false)
      }
    }
    else{
      this.images[this.type](true)

    }
  }

  getSymbol() {
    return this.current
  }

  setType(value) {
    this.type = value || reelsSettings.items.default
    this.setSymbol(this.current)
  }

  getType() {
    return this.type
  }

  animationStop() {
    this.symbol.playSpineStop(this.current)
  }

  animationSticky(cb) {
    this.symbol.playSticky(this.current, cb)
  }

  animationScatter() {
    this.symbol.playSpineFreeSpin()
  }

  animation(totalWin) {
    this.symbol.makeWinAnimation(totalWin)
  }

  playCascadeWin(){
    this.symbol.playCascadeWin()
  }

  playCascadeVanish(){
    this.symbol.playCascadeVanish()
  }

  playCascadeDrop(){
    this.symbol.playCascadeDrop()
  }

  stop() {
    this.setType(this.type)
  }
}
